export default __webpack_public_path__ + "static/media/5.901f3f7a.png";